import { Breadcrumb } from "../../../../core/Breadcrumb.js";
import { cn } from "../../../../foundations/cn.js";
import { useChromeHints } from "../../../shared/chromeHints.js";
import type { BoxPageBreadcrumbContent } from "../../boxPageContent.js";

export interface BoxPageBreadcrumbProps extends BoxPageBreadcrumbContent {
  className?: string;
}

/**
 * Where the box sits, on wide screens. On phones the trail is the top bar's Back, to the page
 * just above the box, so it is hidden here.
 */
export function BoxPageBreadcrumb({ trail, current, className }: BoxPageBreadcrumbProps) {
  const parent = trail.at(-1);
  useChromeHints({ back: parent ? { label: parent.label, href: parent.href } : undefined });
  return (
    <Breadcrumb items={[...trail, { label: current }]} className={cn("max-md:hidden", className)} />
  );
}
